export var SkypeNotificationType;
(function (SkypeNotificationType) {
    SkypeNotificationType[SkypeNotificationType["None"] = 0] = "None";
    SkypeNotificationType[SkypeNotificationType["ToastAndSound"] = 1] = "ToastAndSound";
    SkypeNotificationType[SkypeNotificationType["ToastOnly"] = 2] = "ToastOnly";
})(SkypeNotificationType || (SkypeNotificationType = {}));
export default SkypeNotificationType;
//# sourceMappingURL=SkypeNotificationType.js.map